// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantAccountActivityBriefDto
 */
export interface IParticipantAccountActivityBriefDto {
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBriefDto
     */
    active_accounts_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBriefDto
     */
    canceled_accounts_count?: number;
}

/**
 * Check if a given object implements the IParticipantAccountActivityBriefDto interface.
 */
export function instanceOfIParticipantAccountActivityBriefDto(value: object): value is IParticipantAccountActivityBriefDto {
    return true;
}

export function IParticipantAccountActivityBriefDtoFromJSON(json: any): IParticipantAccountActivityBriefDto {
    return IParticipantAccountActivityBriefDtoFromJSONTyped(json, false);
}

export function IParticipantAccountActivityBriefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantAccountActivityBriefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'active_accounts_count': json['active_accounts_count'] == null ? undefined : json['active_accounts_count'],
        'canceled_accounts_count': json['canceled_accounts_count'] == null ? undefined : json['canceled_accounts_count'],
    };
}

export function IParticipantAccountActivityBriefDtoToJSON(json: any): IParticipantAccountActivityBriefDto {
    return IParticipantAccountActivityBriefDtoToJSONTyped(json, false);
}

export function IParticipantAccountActivityBriefDtoToJSONTyped(value?: IParticipantAccountActivityBriefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active_accounts_count': value['active_accounts_count'],
        'canceled_accounts_count': value['canceled_accounts_count'],
    };
}

